import { InvoiceDataStream } from '@shared/services/gql.service';
import { ServerSideColumnFilterType, ServerSideFilterInfo } from '@shared/utils';

export const InvoiceCheckboxTooltip =
  'Please click Edit button in top right corner to edit invoice data.';

export const ServerSideFilters: ServerSideFilterInfo<InvoiceDataStream>[] = [
  {
    column: 'invoice_no',
    inputPropertyName: 'search',
    transformFunction: (v: unknown) => (typeof v === 'string' ? v.trim() : v),
    type: ServerSideColumnFilterType.Contains,
  },
  {
    column: 'vendor_id',
    inputPropertyName: 'vendors',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'invoice_date',
    inputPropertyName: 'invoiceDate',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'accrual_period',
    inputPropertyName: 'accrualPeriod',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'is_deposit',
    inputPropertyName: 'is_deposit',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'has_prepaid',
    inputPropertyName: 'has_prepaid',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'does_invoice_mappings_match_total',
    inputPropertyName: 'does_invoice_mappings_match_total',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'services_period',
    inputPropertyName: 'services_period',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
  {
    column: 'purchase_order_id',
    inputPropertyName: 'purchase_order',
    type: ServerSideColumnFilterType.IsEqualTo,
  },
];
